module.exports = __webpack_public_path__ + "img/aeroland-payment-image-02.21cef91a.png";